import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Modal } from "../../../theme/Component/Modal";
import useModal, { MODAL_XL } from "../../../theme/Component/hooks/useModal";
import { SalesOrder } from "./SalesOrder";

interface Props {
    idSelector?: number | null;
    salesOrderDate?: any;
    render?: string;
    label?: string;
    onChange: (value: any) => void;
    disabled?: boolean;
}

export const EditorSalesOrder = ({
    idSelector,
    salesOrderDate,
    render,
    label,
    onChange,
    disabled,
}: Props) => {
    const modal = useModal("Catálogo de oportunidades de venta", MODAL_XL);
    const [selected, setSelected] = useState<any>({});
    const [displayValue, setDisplayValue] = useState("");

    const getDisplayValue = (item: any) => {
        if (!item?.IDSalesOrder) return "";

        const customer = item.AccountCustomerName ? ` - ${item.AccountCustomerName}` : "";
        const description = item.Description ? ` - ${item.Description}` : "";
        return `${item.IDSalesOrder} - ${item.SalesOrderDate ?? ""}${customer}${description}`;
    };

    useEffect(() => {
        if (idSelector != null && salesOrderDate != null) {
            const currentValue = {
                IDSalesOrder: idSelector,
                SalesOrderDate: salesOrderDate,
            };
            setSelected(currentValue);
            setDisplayValue(render || getDisplayValue(currentValue));
        } else {
            setSelected({});
            setDisplayValue("");
        }
    }, [idSelector, salesOrderDate, render]);

    const selectValue = () => {
        if (selected.IDSalesOrder == null || selected.SalesOrderDate == null) {
            toast.error("Seleccione una oportunidad de venta válida");
            return;
        }

        setDisplayValue(getDisplayValue(selected));
        onChange(selected);
        modal.close();
    };

    return (
        <>
            {label !== " " && <label>{label ?? "Oportunidad de Venta"}</label>}
            <div
                className={`form-control text-wrap ${disabled ? "bg-light text-muted" : "cursor-pointer"}`}
                style={{ minHeight: "35px" }}
                onClick={() => !disabled && modal.open()}
            >
                {displayValue || <span>Seleccionar...</span>}
            </div>

            <Modal
                modal={modal.modal}
                updateModal={modal.setModal}
                eventModal={selectValue}
                onSubmitLabel="Seleccionar"
            >
                <SalesOrder isModal _onChange={setSelected} />
            </Modal>
        </>
    );
};
